import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  monthlyStatementSearchFrom,
  monthlyStatementsRedirect,
} from '@/features/accounting-reports/monthly-statements-api'

/**
 * The old "Statements by month" address. Each statement now shows By month on
 * its own screen, so a bookmark opens that screen with `view=month` and the
 * same dates; the statement's own route checks the grant.
 */
export const Route = createFileRoute('/_authenticated/accounting/reports/monthly-statements')({
  validateSearch: monthlyStatementSearchFrom,
  beforeLoad: ({ search }) => {
    throw redirect({ ...monthlyStatementsRedirect(search), replace: true })
  },
})
